import { Technology } from '@node/wam-audience-builder'
import { toNumber, deburr, toLower } from 'lodash'

const helpers = {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },
    buildRoutes: countryCode3 => {
        const route = '/common_project/isps.json'
        const params = {
            params: {
                list_limit: 0,
                conditions: {
                    deprecated: 'NO',
                    country_code3: countryCode3
                }
            }
        }
        return { route, params }
    },
    parseData: (data, countryCode2) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                label: val.label,
                isSelectable: true,
                hasChild: false,
                parentJsonKeyName: 'techno_isp',
                jsonKey: {
                    ids: ['isp', toNumber(val.id), countryCode2],
                    name: 'techno_isp_' + val.id,
                    type: 'Techno',
                    subType: 'isp'
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (toLower(deburr(a.label)) > toLower(deburr(b.label)) ? 1 : toLower(deburr(b.label)) > toLower(deburr(a.label)) ? -1 : 0))
    },
    instanciateAll: (data, countryCode) => {
        return data.map(
            isp =>
                new Technology({
                    id: isp.id,
                    label: isp.label,
                    subCategory: 'isp',
                    path: ['Technology', 'Internet Service Providers'],
                    countryCode
                })
        )
    }
}

export default helpers
